import { PROPERTIES_MAP } from './actionTypes';
import { NEARBY_PROPERTIES_MAP } from './actionTypes';
import { SINGLE_PROPERTY_MAP } from './actionTypes';

export const propertiesMap = (propertiesSearch) => ({
  type: PROPERTIES_MAP,
  payload: propertiesSearch,
});

export const nearbyPropertiesMap = (nearbyPropertiesMap) => ({
  type: NEARBY_PROPERTIES_MAP,
  payload: nearbyPropertiesMap,
});

export const singlePropertyMap = (singlePropertyMap) => ({
  type: SINGLE_PROPERTY_MAP,
  payload: singlePropertyMap,
});
